var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('img',{attrs:{"src":require("../assets/img/aaa.jpg"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"txt_c p_a w_100Per",staticStyle:{"top":"400px"}},[_c('div',{staticClass:"btn",on:{"click":_vm.go}},[_vm._v("开启我的收入账单")]),_vm._v(" "),_c('div',[_vm._v("* 以下数据来源1月至11月")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a70ac4b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/index.vue
// module id = null
// module chunks = 